<template>
  <div id="app">
    <!--引用组件head-->
    <headers v-if="headShow"></headers>
    <router-view />
    <!--引用组件foot-->
    <footers v-if="$route.meta.active != 'hotList' && $route.meta.active != 'city'"></footers>
    <!--滚动顶部-->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import headers from './components/header/headers'
import footers from './components/footer/footers'
export default {
  components: {
    headers,
    footers
  },
  data () {
    return {
      headShow: true,
      loginShow: '',
    }
  },
  updated: function () {
    this.loginShow = localStorage.getItem("pbw_user_pc_uid")
  },
  mounted: function () {
  },
  watch: {
    loginShow: function (old, val) {
      if (old) {
        this.headShow = false
        this.$nextTick(() => {
          this.headShow = true
        })
      } else {
        this.headShow = false
        this.$nextTick(() => {
          this.headShow = true
        })
      }
    }
  }
}
</script>

<style lang="scss">
.el-card {
  background: #474664 !important;
}
.el-dialog {
  background: #2f2e49 !important;
}
.el-progress-bar__inner {
  background: linear-gradient(to right, #fe586b, #ff9c58);
}
.el-message {
  top: 150px !important;
}
body {
  font: 12px/1.5 'sans-serif';
  margin: 0;
  padding: 0;
  background: #2f2e49;
}
p,
ul,
ol,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
form {
  margin: 0;
}
h1,
h2,
h3,
em,
i,
th,
caption,
cite,
code,
address {
  font-style: normal;
  font-weight: normal;
}
img {
  border: 0;
}
a {
  color: inherit;
  text-decoration: none;
}
a img {
  vertical-align: top;
  border: 0;
}
ul {
  padding-left: 0;
  list-style: none;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
table {
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
}
th,
td {
  padding: 0;
}
.lf {
  float: left;
}
.rt {
  float: right;
}
.clear:after {
  content: '';
  display: block;
  clear: both;
}
body {
  color: #b1b0c5;
  min-width: 1270px;
  background: #2f2e49;
}
.container {
  width: 100%;
}
.mid {
  margin: 0 auto;
  width: 1270px;
}
.mid--1000 {
  margin: 0 auto;
  width: 1270px;
}
.mid--1150 {
  margin: 0 auto;
  width: 1150px;
}
/*模态遮罩层(modal)*/
.simplemodal-overlay {
  background: black;
}
img:-moz-broken {
  /*隐藏无效图片*/
  display: inline-block;
  white-space: normal;
  overflow: hidden;
}
/*a标签无阴影*/
a.noShadow {
  outline: none;
  text-decoration: none;
}
a.noShadow:active {
  star: expression(this.onFocus=this.blur());
}
/*IE*/
a.noShadow:focus {
  outline: none;
}
/*FF*/
.transit {
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
}
/*设置间距*/
.mt--10 {
  margin-top: 10px !important;
}
.mt--15 {
  margin-top: 15px !important;
}
.mt--20 {
  margin-top: 20px !important;
}
.mt--30 {
  margin-top: 30px !important;
}
.mt--50 {
  margin-top: 50px !important;
}
.mt--60 {
  margin-top: 60px !important;
}
.mt--80 {
  margin-top: 80px !important;
}
.mt--100 {
  margin-top: 100px !important;
}
.ml--10 {
  margin-left: 10px !important;
}
.ml--20 {
  margin-left: 20px !important;
}
.ml--30 {
  margin-left: 30px !important;
}
.ml--40 {
  margin-left: 40px !important;
}
.mr--10 {
  margin-right: 10px !important;
}
.mr--20 {
  margin-right: 20px !important;
}
.mb--10 {
  margin-bottom: 10px !important;
}
.mb--20 {
  margin-bottom: 20px !important;
}
.mb--30 {
  margin-bottom: 30px !important;
}
.mb--50 {
  margin-bottom: 50px !important;
}
.pt--10 {
  padding-top: 10px !important;
}
.pt--20 {
  padding-top: 20px !important;
}
.pt--30 {
  padding-top: 30px !important;
}
.pt--50 {
  padding-top: 50px !important;
}
.pb--10 {
  padding-bottom: 10px !important;
}
.pb--20 {
  padding-bottom: 20px !important;
}
.pb--30 {
  padding-bottom: 30px !important;
}
.pb--50 {
  padding-bottom: 50px !important;
}
/*设置表单宽度*/
.input-20 {
  width: 20px;
}
.input-25 {
  width: 25px;
}
.input-30 {
  width: 30px;
}
.input-40 {
  width: 40px;
}
.input-60 {
  width: 60px;
}
.input-80 {
  width: 80px;
}
.input-120 {
  width: 120px;
}
.input-150 {
  width: 150px;
}
.input-210 {
  width: 210px;
}
.input-250 {
  width: 250px;
}
.input-300 {
  width: 300px;
}
.input-350 {
  width: 350px;
}
.input-400 {
  width: 400px;
}
.input-450 {
  width: 450px;
}
.input-500 {
  width: 500px;
}
.input-550 {
  width: 550px;
}
.input-600 {
  width: 600px;
}
.c--999 {
  color: #999 !important;
}
.c--f60 {
  color: #f60 !important;
}
.c--ff4500 {
  color: #ff4500 !important;
}
.c--05a {
  color: #05a !important;
}
.w--50 {
  width: 50px;
}
.w--100 {
  width: 100px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.dib {
  display: inline-block;
  *zoom: 1;
  *display: inline;
}
.db {
  display: block;
}
.hide {
  display: none;
}
.pos-rel {
  position: relative;
}
.pos-abs {
  position: absolute;
}
.placeholder {
  color: #757575;
}
</style>



// WEBPACK FOOTER //
// src/App.vue